<template>
  <div>
    <h1>Bienvenue dans la Foire aux Questions !</h1>

    <div class="row">
      <div class="col-12 col-md-8 pr-3">
        <h3 class="text-danger">Comment fonctionne Peamoni ?</h3>
        <p>
          Peamoni récupère les cours hebdomadaires et journlaliers d'un des
          instruments accessibles au PEA, en devise EURO. Cela représente
          environ 2000 valeurs, ETFs ou fonds, et plus de 800 cryptos.
          <br /><br />
          Un simple calcul permet de déterminer si la tendance d'un instrument
          est haussière ou baissière, et quels niveaux de prix inversent la
          tendance, c'est <strong>l'indicateur</strong>. <br /><br />
          Par exemple, pour qu'une valeur baissière,
          <strong class="text-danger">dans un canal rouge</strong>, passe
          haussière, elle doit passer haut dessus du haut du canal.
          <br />
          Au contraire, pour qu'une valeur haussière,
          <strong class="text-success">dans un canal vert</strong>, passe
          baissière, elle doit passer sous le bas du canal. <br /><br />
          <strong>
            Les screeners s'appuient simplement sur cette tendance, sa durée et
            sa vitesse pour filtrer des valeurs dans des configurations
            précises.
          </strong>
        </p>

        <h3 class="text-danger mt-5">Quelles données utilise l'indicateur ?</h3>
        <p>
          L'indicateur s'appuie sur les prix des précédentes périodes et une
          moyenne mobile d'environ 30 semaines.
          <br />
          Les hauts et bas d'un canal sont calculés à partir de ces deux
          éléments, en fonction du sens de la tendance.
          <br /><br />
          Envie d'en savoir plus ?
          <strong class="text-primary"
            >Le code de l'indicateur sera bientôt disponible !</strong
          >
        </p>

        <h3 class="text-danger mt-5">Quand sont rafraichies les données ?</h3>
        <p>
          Les données de cotations sont rafraichies toutes les
          <b>30 minutes</b> sur l'interface.<br />
          Ces données sont récupérées depuis le serveur Peamoni, et peuvent
          avoir un décalage de 15 minutes suplémentaires.
          <br /><br />
          Pour connaitre la date de cotation d'une valeur, laissez simplement
          votre souris sur la valeur. Une popup apparaitra pour vous donner
          l'information.
        </p>

        <h3 class="text-danger mt-5">Je ne trouve pas une valeur !</h3>
        <p>
          Si un instrument normalement accessible au PEA n'est pas disponible
          dans la recherche ou la liste des instruments, vérifiez d'abord si un
          filtre sur les volumes ou les prix n'empêche pas son affichage.
          <br /><br />
          Si ce n'est pas le cas, ou si c'est une crypto que vous ne trouvez
          pas, vous pouvez nous écrire sur <strong>Twitter</strong> en message
          privé, nous nous occuperons de l'ajouter dans les plus brefs délais !
        </p>

        <h3 class="text-danger mt-5" v-if="mode !== 'crypto'">
          Comment fonctionnent les filtres ?
        </h3>
        <p v-if="mode !== 'crypto'">
          Depuis votre
          <router-link class="pointer text-primary" tag="b" to="/pages/user"
            >profil</router-link
          >, vous pouvez modifier les filtres. Ils s'appliquent instantanément à
          toute l'application (instruments, screeners ...) afin de vous aider à
          cibler des valeurs (peu ou beaucoup de volumes, ETFs ...).
          <br /><br />
          <b
            >Seules les valeurs déjà présentes dans votre portefeuille ne sont
            pas filtrées.</b
          >
          <br /><br />
          <span>
            Des filtres par défaut peuvent être appliqués dans le paramétrage de
            l'application, en fonction de votre expérience.
            <br />Vous pouvez à tout moment les modifier ou réappliquer les
            valeurs par défaut.
          </span>
        </p>
      </div>

      <card class="col-12 col-md-4">
        <h4 class="text-danger">Bugs constatés sur la version actuelle :</h4>
        <ul>
          <li>
            <b>Valeur abérante dans le dashboard :</b>
            Le capital initial ou le cash disponible prennent parfois une valeur
            abérante. Rendez-vous dans votre profil pour corriger manuellement
            la valeur qui pose problème.
          </li>
          <li>
            <b>Seuil de breakout :</b>
            Certains seuils de breakout affichés dans le résumé d'une valeur
            (onglet Instruments) ou dans les Screeners, sont mal calculés et ne
            sont pas en adéquation avec le graphique hebdo.
          </li>
        </ul>
        <p class="text-muted text-center">
          Vous avez trouvé un autre bug ?<br />
          Désolé, ça arrive =)<br />
          Vous pouvez nous le signaler sur Twitter !
        </p>
      </card>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters({
      mode: "auth/mode"
    })
  },
  metaInfo() {
    return {
      title: "FAQ Peamoni"
    };
  }
};
</script>
<style></style>
